const columns = [
  {
    title: '中控型号',
    dataIndex: 'model',
    key: 'model',
    align: 'center',
    sorter: true,
  },
  {
    title: '中控硬件版本',
    dataIndex: 'hardVersion',
    key: 'hardVersion',
    align: 'center',
    sorter: true,
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
  },
  {
    title: '最后修改时间',
    dataIndex: 'lastModificationTime',
    key: 'lastModificationTime',
    align: 'center',
    sorter: true,
    width: '15%',
    scopedSlots: { customRender: 'lastModificationTime' },
  },
  {
    title: '操作',
    key: 'action',
    width: '30%',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
const selectOption = [
  {
    value: 'hardVersion',
    label: '中控硬件版本',
  },
  {
    value: 'remark',
    label: '备注',
  },
];
const optionEnum = {
  HARDVERSION: 'hardVersion',
  REMARK: 'remark',
};
export default {
  columns,
  selectOption,
  optionEnum,
};
